/* design wording for image alt text (SEO): shared by the product scripts */
window.plDesignPhrase = window.plDesignPhrase || function (n) { return ({ 'Cosmos': 'Cosmos starry galaxy design', 'Cream': 'Cream solid design', 'Dream': 'Dream pastel sunset design', 'Garden': 'Garden green floral design', 'Navy': 'Navy solid blue design', 'Olive': 'Olive solid green design', 'Seaside Cabana': 'Seaside Cabana blue stripe design', 'Sienna': 'Sienna terracotta red design', 'Sky': 'Sky solid light blue design', 'Sunset Cabana': 'Sunset Cabana orange stripe design', 'Blush': 'Blush solid pink design', 'Sand': 'Sand soft taupe design', 'Gray': 'Gray solid light gray design', 'Sage': 'Sage solid soft green design', 'Ocean': 'Ocean solid steel blue design', 'Lavender': 'Lavender solid purple design', 'Yellow': 'Yellow solid golden yellow design', 'Blue Polka': 'Blue Polka light blue polka dot design', 'Pink Polka': 'Pink Polka pink polka dot design', 'Green Polka': 'Green Polka mint green polka dot design', 'White Polka': 'White Polka white with colorful dots design', 'Confetti': 'Confetti colorful sprinkle design', 'Daisy Dot': 'Daisy Dot gray with white daisy dot design', 'Green Check': 'Green Check sage green gingham check design', 'Meadow': 'Meadow warm tan floral design', 'Petal': 'Petal pink floral design', 'Polka Dot': 'Polka Dot cream polka dot design', 'Red Check': 'Red Check coral red gingham check design', 'Sprinkles': 'Sprinkles lavender sprinkle design', 'White': 'White solid white design' })[n] || (n + ' design'); };
/* Printed Love 3.0 · Everyday Love Blanket product page (Shopify port of the prototype's pdp.js).
   One module per section (init/destroy, shopify:section:load/unload). Design and Size are real variants; the photo is an Upload-Lift file URL. */
(function () {
  'use strict';

  var CFG = null;
  function cfg() { if (!CFG) { var el = document.querySelector('[data-pl-product-json]'); CFG = el ? JSON.parse(el.textContent) : { variants: [], designs: [] }; } return CFG; }
  var SIZES = {
    small:  { label: '30 × 40 in', cm: '76 × 102 cm', w: 30, h: 40, use: 'A lap blanket for the armchair, or a crate cover. Great for pets and for travel too.' },
    medium: { label: '50 × 60 in', cm: '127 × 152 cm', w: 50, h: 60, use: 'A sofa throw big enough to curl up under together.' },
    large:  { label: '60 × 80 in', cm: '152 × 203 cm', w: 60, h: 80, use: 'Covers the top of a queen bed, or two people and a dog on the couch.' }
  };
  var PRICES = { small: 65, medium: 85, large: 115 }, COMPARE = { small: 75, medium: 95, large: 125 }; // refreshed from the real variants in loadConfig()
  var FREE_SHIP_MIN = 100, SHIP_COST = 9.99;
  var SWATCH = { Cream: '#F9EBDD', Sienna: '#9D4946', Sky: '#B4DCDF', Olive: '#636B56', Navy: '#243D67', 'Seaside Cabana': '#BCC8C7', 'Sunset Cabana': '#E1B39B', Garden: '#7C7755', Dream: '#E7CBA4', Cosmos: '#595B6D', Blush: '#F4C1BE', Sand: '#E3D4CF', Gray: '#D0D0D0', Sage: '#A4B08C', Ocean: '#567288', Lavender: '#B5AFD1', Yellow: '#FEC96D', 'Blue Polka': '#BAD9F7', 'Pink Polka': '#FAD5E2', 'Green Polka': '#D4EBC4', 'White Polka': '#FDFBFB', Confetti: '#F1F0EC', 'Daisy Dot': '#D8DCDB', 'Green Check': '#C4CAB1', Meadow: '#DDCDB5', Petal: '#EDB0B0', 'Polka Dot': '#EFE8DE', 'Red Check': '#DA9984', Sprinkles: '#B6B0CA', White: '#FFFFFF' };
  var LIGHT = { Sienna: 1, Olive: 1, Navy: 1, Garden: 1, Cosmos: 1, Ocean: 1 }; // dark designs get light lettering on the preview
  var DESIGNS = [];
  function loadConfig() {
    CFG = null;
    DESIGNS = cfg().designs.map(function (d) { return { name: d.name, sw: SWATCH[d.name] || '#E8DFD3', light: !!LIGHT[d.name], tile: d.tile, art: d.art, img: d.img, imgBig: d.imgBig, blank: d.blank, blankBig: d.blankBig }; });
    var sizeKey = {}; Object.keys(SIZES).forEach(function (k) { sizeKey[SIZES[k].label] = k; });
    cfg().variants.forEach(function (v) { var k = sizeKey[v.size]; if (k) { PRICES[k] = v.price / 100; COMPARE[k] = v.compare ? v.compare / 100 : 0; } });
  }
  function design(name) { for (var i = 0; i < DESIGNS.length; i++) if (DESIGNS[i].name === name) return DESIGNS[i]; return DESIGNS[0]; }
  function variantFor(dn, sk) { var v = cfg().variants, label = SIZES[sk].label; for (var i = 0; i < v.length; i++) if (v[i].design === dn && v[i].size === label) return v[i]; return null; }
  function paintDesign(el, d, large) {
    el.style.setProperty('--sw', d.sw);
    el.style.backgroundImage = 'url(' + (large ? d.art : d.tile) + ')';
    el.style.backgroundSize = 'cover'; el.style.backgroundPosition = 'center';
  }
  // Delivery estimate fallback (only when no Essential Estimated Delivery block is on the page): 2-4 days to make + 3-6 days U.S. transit.
  var MAKE = [2, 4], SHIP = [3, 6];
  var reduceMotion = matchMedia('(prefers-reduced-motion: reduce)');
  var state = { design: 'Garden', font: 'classic', fontSet: false, designTouched: false, size: 'small', name: '', photo: null, photoName: '', photoUrl: null, uploading: false, preview: false, designSet: false, sizeSet: false, nameSkip: false };
  function emit() { document.dispatchEvent(new CustomEvent('pl:change', { detail: state })); }
  function money(n) { return '$' + (Math.round(n * 100) % 100 ? n.toFixed(2) : n); }
  function smooth(e0, e1, x) { var t = Math.min(1, Math.max(0, (x - e0) / (e1 - e0))); return t * t * (3 - 2 * t); }
  function scrollToEl(el, block) { el.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: block || 'center' }); }
  function addDays(from, n) { return new Date(from.getFullYear(), from.getMonth(), from.getDate() + n); }
  var fmt = new Intl.DateTimeFormat('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
  function eta() { var now = new Date(); return fmt.format(addDays(now, MAKE[0] + SHIP[0])) + ' – ' + fmt.format(addDays(now, MAKE[1] + SHIP[1])); }
  /* Next step, in the buy box's order: design, size, their name (optional, skippable), photo, then Add to cart. */
  function nextStep() {
    if (!state.photo) return { key: 'photo', label: 'Add your photo' };
    if (!state.name && !state.nameSkip) return { key: 'name', label: 'Next: add their name' };
    if (!state.sizeSet) return { key: 'size', label: 'Next: confirm your size' };
    return { key: 'cart', label: 'Add to cart · ' + money(PRICES[state.size]) };
  }
  function shipCost(subtotal) { return subtotal >= FREE_SHIP_MIN ? 0 : SHIP_COST; }

  /* ======================================================================
     MODULE: product (gallery + creation form + sticky bar)
     ====================================================================== */
  function initProduct(root) {
    var ac = new AbortController(), sig = { signal: ac.signal };
    var track = root.querySelector('[data-pl-track]');
    var slides = Array.prototype.slice.call(track.children);
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.pl-gallery__thumb'));
    var form = root.querySelector('[data-pl-form]');
    var nameIn = form.querySelector('#pl-name');
    var fileIn = form.querySelector('#pl-photo');
    var current = 0, photoFrom = 'uploaded';
    var slot = form.querySelector('[data-pl-upload-slot]'), variantInput = form.querySelector('[data-pl-variant-id]');
    var leadImg = root.querySelector('[data-pl-lead-img]'), leadThumb = root.querySelector('[data-pl-lead-thumb]');

    /* gallery */
    // Desktop shows the images stacked (CSS): the variant image leads, lifestyle images follow two-up
    var stacked = matchMedia('(min-width: 990px)');
    // The buy box is taller than the screen: scroll through it once, then keep its bottom in view beside the stack
    var buy = document.querySelector('.pl-product__buy');
    function pinBuy() { buy.style.setProperty('--pl-buy-top', Math.min(20, innerHeight - buy.offsetHeight - 20) + 'px'); }
    var buyRO = new ResizeObserver(pinBuy); buyRO.observe(buy);
    addEventListener('resize', pinBuy, sig);
    function go(i, instant) {
      current = (i + slides.length) % slides.length;
      if (stacked.matches) { markThumb(current); return; }
      track.scrollTo({ left: track.clientWidth * current, behavior: instant || reduceMotion.matches ? 'auto' : 'smooth' });
      markThumb(current);
    }
    function markThumb(i) {
      thumbs.forEach(function (t, k) { t.setAttribute('aria-current', String(k === i)); });
      var strip = thumbs[i].parentNode, t = thumbs[i]; // keep the current thumb in view when the strip scrolls
      if (strip.scrollWidth > strip.clientWidth) strip.scrollTo({ left: t.offsetLeft - (strip.clientWidth - t.offsetWidth) / 2, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    }
    var raf = 0;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i !== current) { current = i; markThumb(i); }
      });
    }, { passive: true, signal: ac.signal });
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }, sig); });
    root.querySelector('[data-pl-prev]').addEventListener('click', function () { go(current - 1); }, sig);
    root.querySelector('[data-pl-next]').addEventListener('click', function () { go(current + 1); }, sig);

    /* swiping forward on the last photo loops back to the first */
    var swipeX = null;
    track.addEventListener('touchstart', function (e) { swipeX = e.touches.length === 1 ? e.touches[0].clientX : null; }, { passive: true, signal: ac.signal });
    track.addEventListener('touchend', function (e) {
      if (swipeX === null) return;
      var dx = e.changedTouches[0].clientX - swipeX; swipeX = null;
      if (dx < -40 && current === slides.length - 1 && track.scrollLeft >= track.scrollWidth - track.clientWidth - 4) go(0);
    }, { passive: true, signal: ac.signal });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
    }, sig);

    /* design */
    // Re-pointing an image at the URL it already has restarts its load and resets LCP; only swap when it really changes
    function setImg(el, src, srcset) {
      if (!el || !src) return;
      var cur = el.getAttribute('src');
      if (cur && new URL(cur, location.href).href === new URL(src, location.href).href) return;
      el.src = src; if (srcset) el.srcset = srcset;
    }
    function setDesign(name, fromElsewhere) {
      var d = design(name);
      state.design = d.name;
      var r = form.querySelector('input[name="design"][value="' + d.name + '"]');
      if (r) r.checked = true;
      // First gallery image = this background's standardized mockup
      var nn = (cfg().nonameLead || {})[d.name], leadTag = root.querySelector('[data-pl-lead-tag]');
      if (nn) { setImg(leadImg, nn[0], nn[0] + ' 720w, ' + nn[1] + ' 1400w'); setImg(leadThumb, nn[0]); }
      else if (d.img) { setImg(leadImg, d.img, d.img + ' 720w, ' + d.imgBig + ' 1400w'); setImg(leadThumb, d.img); }
      var leadDn = root.querySelector('[data-pl-lead-design]'); if (leadDn) leadDn.textContent = d.name;
      if (leadTag) { leadTag.hidden = !nn; leadTag.style.color = d.light ? '#FCEDDE' : '#342E2A'; leadTag.style.textShadow = d.light ? '0 1px 1.5px rgb(0 0 0 / .22)' : 'none'; }
      var leadBlank = root.querySelector('[data-pl-lead-blank]'), leadName = root.querySelector('[data-pl-lead-name]');
      if (leadBlank) setImg(leadBlank, d.blank, d.blank + ' 720w, ' + d.blankBig + ' 1200w');
      if (leadName) leadName.style.color = d.light ? '#FCEDDE' : '#342E2A';
      leadImg.alt = (document.getElementById('pl-title') ? document.getElementById('pl-title').textContent.trim() : 'Everyday Love Blanket') + ' ' + d.name + ' Printed Love';
      if (!fromElsewhere) go(0); else go(0, true);
      update();
    }

    /* photo: our upload box drives Upload-Lift (its widget is hidden); falls back to a plain file input without the app */
    function lift() { return slot.querySelector('input.filepond--browser'); }
    function showPhoto(src, name, status) {
      state.photo = src; state.photoName = name;
      form.querySelector('[data-pl-thumb]').src = src;
      form.querySelector('[data-pl-file]').textContent = name;
      form.querySelector('[data-pl-upload-ok]').textContent = status || 'Photo added';
      form.querySelector('[data-pl-upload-empty]').hidden = true;
      form.querySelector('[data-pl-upload-done]').hidden = false;
      clearErr('photo');
    }
    function clearPhoto() {
      state.photo = null; state.photoName = ''; state.photoUrl = null; state.uploading = false; state.pendingAdd = false;
      form.querySelector('[data-pl-upload-empty]').hidden = false;
      form.querySelector('[data-pl-upload-done]').hidden = true;
      PL.memory.set({ photo: null, photoName: null, photoFrom: null });
      var carried = form.querySelector('[data-pl-carried]'); if (carried) carried.remove();
      update();
    }
    function openPicker() { var f = lift(); (f || fileIn).click(); }
    form.addEventListener('click', function (e) {
      var lab = e.target.closest('label[for="pl-photo"]'); if (!lab || !lift()) return;
      e.preventDefault(); openPicker();
    }, sig);
    function onPicked(file) {
      if (!file) return;
      if (!/^image\//.test(file.type) && !/\.(heic|heif)$/i.test(file.name)) { showErr('photo', "That file isn't a photo. Try a JPG, PNG or HEIC from your camera roll."); return false; }
      if (state.localUrl) URL.revokeObjectURL(state.localUrl);
      state.localUrl = URL.createObjectURL(file);
      photoFrom = 'uploaded'; state.photoUrl = null; state.uploading = !!lift();
      showPhoto(state.localUrl, file.name, state.uploading ? 'Uploading…' : 'Photo added');
      var carried = form.querySelector('[data-pl-carried]'); if (carried) carried.remove();
      update();
      return true;
    }
    fileIn.addEventListener('change', function () { var f = fileIn.files && fileIn.files[0]; if (!onPicked(f)) fileIn.value = ''; }, sig);
    slot.addEventListener('change', function (e) { if (e.target.matches('input.filepond--browser')) onPicked(e.target.files && e.target.files[0]); }, sig);
    window.addEventListener('upload:added', function (ev) {
      var f = ev.detail; if (!f || !f.url || (f.meta && f.meta.variant === 'thumbnail')) return;
      state.photoUrl = f.url; state.uploading = false; photoFrom = 'uploaded'; if (state.pendingAdd) { state.pendingAdd = false; form.requestSubmit(); }
      if (!state.photo) showPhoto(f.url, f.name || 'Your photo'); else form.querySelector('[data-pl-upload-ok]').textContent = 'Photo added';
      PL.memory.keepPhoto(f.url, f.name || 'Your photo');
      clearErr('photo'); update();
    }, sig);
    window.addEventListener('upload:removed', function () { if (!state.uploading) clearPhoto(); }, sig);
    /* a photo they added on another product: reuse its file URL, no second upload */
    function useCarried(c) {
      photoFrom = 'reused'; state.photoUrl = c.src; state.uploading = false;
      showPhoto(c.src, c.name);
      PL.memory.carriedNote(fileIn.closest('.pl-field'), c.from);
    }

    /* errors: point at the next step, never a wall of red */
    function showErr(which, msg) {
      var el = form.querySelector('[data-pl-err="' + which + '"]');
      if (msg) el.textContent = msg;
      el.hidden = false;
      el.closest('.pl-field').classList.add('is-invalid');
      (which === 'name' ? nameIn : fileIn).setAttribute('aria-invalid', 'true');
    }
    function clearErr(which) {
      var el = form.querySelector('[data-pl-err="' + which + '"]');
      el.hidden = true;
      el.closest('.pl-field').classList.remove('is-invalid');
      (which === 'name' ? nameIn : fileIn).removeAttribute('aria-invalid');
    }

    form.addEventListener('change', function (e) {
      var t = e.target;
      if (t.name === 'font') { state.font = t.value; state.fontSet = true; PL.memory.set({ font: t.value }); return update(); }
      if (t.name === 'design') { state.designSet = true; state.designTouched = true; PL.memory.set({ design: t.value }); return setDesign(t.value); }
      if (t.name === 'size') { state.size = t.value; state.sizeSet = true; }
      if (t.hasAttribute('data-pl-preview')) state.preview = t.checked;
      update();
    }, sig);
    nameIn.addEventListener('input', function () {
      state.name = nameIn.value.trim();
      PL.memory.set({ name: state.name || null });
      update();
    }, sig);

    var leadChange = root.querySelector('[data-pl-lead-change]');
    if (leadChange) leadChange.addEventListener('click', function () { document.dispatchEvent(new CustomEvent('pl:pick-photo')); }, sig);
    var leadPick = root.querySelector('[data-pl-lead-pick]');
    if (leadPick) leadPick.addEventListener('click', function () { document.dispatchEvent(new CustomEvent('pl:pick-photo')); }, sig);
    var leadNameEl = root.querySelector('[data-pl-lead-name]');
    if (leadNameEl) leadNameEl.addEventListener('click', function () { nameIn.focus(); try { nameIn.scrollIntoView({ block: 'center', behavior: reduceMotion.matches ? 'auto' : 'smooth' }); } catch (e) {} }, sig);

    function stepTarget(key) {
      return key === 'design' ? document.querySelector('[data-pl-swatches]') : key === 'size' ? document.querySelector('#pl-size .pl-size__body')
        : key === 'name' ? nameIn : key === 'photo' ? fileIn.closest('.pl-field') : atc;
    }
    function syncNext() {
      var n = nextStep(), tgt = stepTarget(n.key);
      document.querySelectorAll('[data-pl-nextstep-label]').forEach(function (l) { l.textContent = n.label; });
      document.querySelectorAll('[data-pl-strip-label]').forEach(function (l) { l.textContent = started() ? 'Finish your blanket' : 'Create your blanket'; });
      document.querySelectorAll('[data-pl-nextstep]').forEach(function (b) {
        b.classList.toggle('is-photo', n.key === 'photo'); b.classList.toggle('is-cart', n.key === 'cart');
        // the arrow points to where the step is (design and photo are in place for the photo step, which opens the picker)
        b.classList.toggle('is-down', n.key !== 'cart' && n.key !== 'photo' && !!tgt && !!(b.compareDocumentPosition(tgt) & Node.DOCUMENT_POSITION_FOLLOWING));
        // optional name: a quiet "No name, thanks" beside the button
        var card = b.parentNode, skip = card.querySelector(':scope > [data-pl-skipname]');
        if (n.key === 'name' && !skip) { skip = document.createElement('button'); skip.type = 'button'; skip.className = 'pl-skipname'; skip.setAttribute('data-pl-skipname', ''); skip.textContent = 'No name, thanks'; card.appendChild(skip); }
        if (skip) skip.hidden = n.key !== 'name';
      });
    }
    function started() { return !!(state.designSet || state.sizeSet || state.photo || state.name); }
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-pl-skipname]')) return;
      state.nameSkip = true; update();
    }, sig);
    /* The slim button before the FAQ: not started -> the top of the page (the personalization); started -> the card for the step still to do
       (photo: the design card's Add your photo button; size: the size guide's Choose this size; all done: the size card with Add to cart) */
    document.addEventListener('click', function (e) {
      var st = e.target.closest('[data-pl-strip]'); if (!st) return;
      e.preventDefault();
      // always back up to the main personalization box at the top of the page
      var box = document.querySelector('#pl-buy [data-pl-form]') || document.querySelector('#pl-buy');
      scrollToEl(box, 'start');
    }, sig);
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-pl-nextstep]'); if (!a) return;
      e.preventDefault();
      var n = nextStep(), target, focusEl;
      if (n.key === 'cart') { form.requestSubmit(); return; } // everything's done: add it right here and open the cart drawer
      if (n.key === 'photo') { openPicker(); return; } // pick the photo right here; the button then moves on to the next step
      else if (n.key === 'size') { target = stepTarget('size'); focusEl = document.querySelector('#pl-size [role="tab"][aria-selected="true"]'); } // the size guide
      else if (n.key === 'design') { target = stepTarget('design'); focusEl = target.querySelector('[aria-pressed="true"]') || target.querySelector('.pl-look'); } // the designs
      else if (n.key === 'name') { target = nameIn.closest('.pl-field'); focusEl = nameIn; } // the name field in the buy box
      else { target = atc; focusEl = atc; }
      scrollToEl(target, 'center');
      if (focusEl) focusEl.focus({ preventScroll: true });
      target.classList.remove('is-next'); void target.offsetWidth; target.classList.add('is-next');
    }, sig);
    function update() {
      // the top photo is Charlie's mockup until they add a photo; then it is their live preview
      var ls = root.querySelector('[data-pl-lead]'), ln = root.querySelector('[data-pl-lead-name]');
      var lpt = root.querySelector('[data-pl-lead-portrait]'), lph = root.querySelector('[data-pl-lead-ph]');
      var lchg = root.querySelector('[data-pl-lead-change]'); if (lchg) lchg.hidden = !state.photo;
      var heroLive = !!state.photo; // Charlie's mockup (in their chosen design, with their name and font) until a photo is added
      if (ls) { if (heroLive) ls.setAttribute('data-pl-live', ''); else ls.removeAttribute('data-pl-live'); }
      var lt = root.querySelector('[data-pl-lead-tag]'); if (lt) lt.textContent = state.name || 'Charlie';
      if (ln) { ln.textContent = state.name || ''; if (state.name) ln.removeAttribute('data-empty'); else ln.setAttribute('data-empty', ''); }
      if (lpt) {
        var lim = lpt.querySelector('img.pl-illo__photo');
        if (state.photo) {
          if (!lim) { lim = document.createElement('img'); lim.className = 'pl-illo__photo'; lim.alt = ''; lpt.appendChild(lim); }
          if (lim.getAttribute('src') !== state.photo) lim.src = state.photo;
          lpt.classList.add('has-photo'); if (lph) lph.hidden = true;
        } else { if (lim) lim.remove(); lpt.classList.remove('has-photo'); if (lph) lph.hidden = false; }
      }
      document.documentElement.setAttribute('data-pl-font', state.font);
      var d = design(state.design), vv = variantFor(d.name, state.size);
      if (vv) { variantInput.value = vv.id; try { var u = new URL(location.href); u.searchParams.set('variant', vv.id); history.replaceState(null, '', u); } catch (e) {} }
      root.querySelectorAll('[data-pl-size-price-opt]').forEach(function (el) { el.textContent = money(PRICES[el.getAttribute('data-pl-size-price-opt')]); });
      syncNext();
      var price = PRICES[state.size];
      var was = COMPARE[state.size];
      root.querySelector('[data-pl-price]').textContent = money(price);
      root.querySelector('[data-pl-atc-price]').textContent = money(price);
      var wasEl = root.querySelector('[data-pl-was]');
      wasEl.hidden = !was;
      if (was) root.querySelector('[data-pl-was-val]').textContent = money(was);
      root.querySelector('[data-pl-design-name]').textContent = d.name;

      var bits = [d.name, SIZES[state.size].label];
      if (state.name) bits.push(state.name); bits.push({ classic: 'Classic font', signature: 'Signature font', playful: 'Playful font' }[state.font]);
      root.querySelector('[data-pl-summary-text]').textContent = bits.join(' · ');
      var st = root.querySelector('[data-pl-summary-thumb]');
      if (state.photo) { st.style.backgroundImage = 'url(' + state.photo + ')'; st.style.backgroundSize = 'cover'; }
      else paintDesign(st, d);

      var etaEl = root.querySelector('[data-pl-eta]'); if (etaEl) etaEl.textContent = eta();
      var ship = root.querySelector('[data-pl-ship-line]');
      var free = shipCost(price) === 0;
      ship.textContent = free ? 'This blanket ships free.' : 'Shipping $9.99, free on orders over $99.';
      ship.classList.toggle('is-free', free);

      var sticky = document.querySelector('[data-pl-sticky-text]');
      if (sticky) sticky.textContent = d.name + ' · ' + SIZES[state.size].label + ' · ' + money(price);
      emit();
    }

    /* add to cart: submit the real product form so Upload-Lift's own fields (which link the file to the order) go along */
    /* The main Add to cart button goes through our own submit handler, the same way the sticky bar and the "Next" cards do.
       Upload-Lift otherwise blocks the click when the photo came from another product (no upload on this page) and says nothing. */
    window.addEventListener('click', function (e) {
      var b = e.target && e.target.closest && e.target.closest('[data-pl-atc]'); if (!b || !form.contains(b)) return;
      e.preventDefault(); e.stopImmediatePropagation();
      form.requestSubmit();
    }, { capture: true, signal: ac.signal });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!state.photo) { showErr('photo', 'Add a photo of your pet to continue.'); scrollToEl(fileIn.closest('.pl-field')); fileIn.focus({ preventScroll: true }); return; }
      if (state.uploading) { state.pendingAdd = true; showErr('photo', 'Your photo is still uploading. One moment.'); return; }
      if (!state.photoUrl) { showErr('photo', "We couldn't save your photo. Please choose it again."); return; }
      var v = variantFor(state.design, state.size); if (!v) return;
      var fd = new FormData(form);
      fd.set('id', v.id); fd.set('quantity', '1');
      if (!fd.get('properties[Pet Photo]')) fd.set('properties[Pet Photo]', state.photoUrl); // a reused photo has no widget field
      fd.set('properties[_photo_from]', photoFrom); fd.set('properties[_set_id]', PL.setId());
      if (state.name) fd.set('properties[Pet Name]', state.font === 'playful' ? state.name.toUpperCase() : state.name); else fd.delete('properties[Pet Name]');
      fd.delete('font'); fd.set('properties[Font]', fontLabels[state.font]);
      if (!state.preview) fd.delete('properties[Design preview]');
      var btn = form.querySelector('[data-pl-atc]'); btn.disabled = true;
      window.PLCart.addForm(fd).catch(function (er) { showErr('photo', er.message || 'Something went wrong. Please try again.'); }).then(function () { btn.disabled = false; });
    }, sig);

    /* other sections ask for things through events */
    document.addEventListener('pl:set-size', function (e) {
      var r = form.querySelector('input[name="size"][value="' + e.detail + '"]');
      if (r) { r.checked = true; state.size = e.detail; state.sizeSet = true; update(); }
    }, sig);
    document.addEventListener('pl:set-design', function (e) { state.designSet = true; state.designTouched = true; PL.memory.set({ design: e.detail }); setDesign(e.detail, true); }, sig);
    document.addEventListener('pl:pick-photo', openPicker, sig);

    /* sticky bar: on phones only, once the real button has scrolled away */
    var bar = document.querySelector('[data-pl-sticky]');
    var atc = form.querySelector('[data-pl-atc]');
    var closeSec = document.querySelector('[data-pl-site="set"]'); // the last section before the footer
    var barRaf = 0;
    // Position check, not IntersectionObserver: a jump (anchor link, fast fling)
    // can move the button from below the viewport to above it without ever
    // intersecting, and an observer would never fire.
    function syncBar() {
      barRaf = 0;
      var passed = atc.getBoundingClientRect().bottom < 0;
      var c = closeSec ? closeSec.getBoundingClientRect() : null;
      var closeVisible = c ? (c.top < innerHeight && c.bottom > 0) : false;
      var on = passed && !closeVisible && innerWidth < 990;
      bar.classList.toggle('is-on', on);
      bar.setAttribute('aria-hidden', String(!on));
      if (on) bar.removeAttribute('inert'); else bar.setAttribute('inert', '');
      document.documentElement.classList.toggle('pl-sticky-on', on);
    }
    function queueBar() { if (!barRaf) barRaf = requestAnimationFrame(syncBar); }
    addEventListener('scroll', queueBar, { passive: true, signal: ac.signal });
    addEventListener('resize', queueBar, sig);
    syncBar();
    bar.querySelector('[data-pl-sticky-btn]').addEventListener('click', function () { form.requestSubmit(); }, sig);

    // restore state into a reloaded section
    var s0 = form.querySelector('input[name="size"][value="' + state.size + '"]'); if (s0) s0.checked = true;
    // ?design=Seaside%20Cabana (e.g. from the pillow's "Make it a set") preselects a design
    // Start from what they're making: ?design= from a link, else the background they last chose on any product
    var sd = PL.memory.startDesign(); if (sd) { state.design = sd; state.designSet = true; } // from a link or earlier browsing: already chosen
    var fontLabels = { classic: 'Classic', signature: 'Signature', playful: 'Playful' };
    var mf = PL.memory.get().font; if (mf && fontLabels[mf]) { state.font = mf; state.fontSet = true; var fr = form.querySelector('input[name="font"][value="' + mf + '"]'); if (fr) fr.checked = true; }
    var mem = PL.memory.get();
    if (mem.name && !nameIn.value) { nameIn.value = mem.name; state.name = mem.name; }
    var carried = !state.photo && PL.memory.carriedPhoto(); if (carried) useCarried(carried);
    setDesign(state.design, true);

    /* Warm the browser cache for every design's mockup and preview blanket, a few at a time while the page is idle,
       so picking a swatch swaps the photo instantly instead of waiting on the network. */
    function preloadDesigns() {
      var q = [];
      DESIGNS.forEach(function (d) {
        if (d.img) q.push({ src: d.img, srcset: d.img + ' 720w, ' + d.imgBig + ' 1400w' });
        if (d.blank) q.push({ src: d.blank });
      });
      var i = 0;
      (function next() {
        if (i >= q.length) return;
        var it = q[i++], im = new Image();
        if (it.srcset) { im.sizes = leadImg.sizes || '100vw'; im.srcset = it.srcset; }
        im.src = it.src;
        setTimeout(next, 90);
      })();
    }
    if ('requestIdleCallback' in window) requestIdleCallback(preloadDesigns, { timeout: 2500 }); else setTimeout(preloadDesigns, 1500);

    return function destroy() {
      ac.abort(); cancelAnimationFrame(raf); cancelAnimationFrame(barRaf); buyRO.disconnect();
      bar.classList.remove('is-on'); document.documentElement.classList.remove('pl-sticky-on');
    };
  }

  /* ======================================================================
     MODULE: transform (the signature move)
     p (0..1) across the pinned travel drives two eased values:
       a: artwork reveal  (photo card shrinks to a keepsake in the corner)
       b: pull back from the painted face to the whole blanket
     Purely decorative motion: every step is also a button, and under
     reduced motion the same story renders as three stills.
     ====================================================================== */
  function initTransform(root) {
    var ac = new AbortController(), sig = { signal: ac.signal };
    var frame = root.querySelector('[data-pl-frame]');
    var steps = Array.prototype.slice.call(root.querySelectorAll('.pl-step'));
    var TARGETS = [0.06, 0.5, 0.97];
    var raf = 0, lastStep = -1;

    function progress() {
      var r = root.getBoundingClientRect();
      var travel = root.offsetHeight - innerHeight;
      return travel > 0 ? Math.min(1, Math.max(0, -r.top / travel)) : 0;
    }
    function paint() {
      raf = 0;
      if (reduceMotion.matches) { frame.style.setProperty('--a', 1); frame.style.setProperty('--b', 1); return; }
      var p = progress();
      var a = smooth(0.18, 0.46, p), b = smooth(0.56, 0.86, p);
      frame.style.setProperty('--a', a.toFixed(3));
      frame.style.setProperty('--b', b.toFixed(3));
      frame.setAttribute('data-sc-verify-state', a.toFixed(2) + '|' + b.toFixed(2));
      var s = p < 0.33 ? 0 : p < 0.72 ? 1 : 2;
      if (s !== lastStep) {
        lastStep = s;
        steps.forEach(function (st, i) { if (i === s) st.setAttribute('aria-current', 'step'); else st.removeAttribute('aria-current'); });
      }
    }
    function queue() { if (!raf) raf = requestAnimationFrame(paint); }
    addEventListener('scroll', queue, { passive: true, signal: ac.signal });
    addEventListener('resize', queue, sig);
    reduceMotion.addEventListener('change', queue, sig);

    steps.forEach(function (st, i) {
      st.addEventListener('click', function () {
        if (reduceMotion.matches) return;
        var top = root.getBoundingClientRect().top + scrollY;
        var travel = root.offsetHeight - innerHeight;
        scrollTo({ top: top + travel * TARGETS[i], behavior: 'smooth' });
      }, sig);
    });
    // Always Nacho's example (photo → artwork → blanket); the shopper's upload isn't used here, so steps 2 and 3 stay true
    paint();

    return function destroy() { ac.abort(); if (raf) cancelAnimationFrame(raf); };
  }

  /* ======================================================================
     MODULE: looks (visual merchandising: one big blanket, every design)
     The real blanket in each design (no art or name), with their name and photo laid over it.
     Tapping a design updates the buy box through pl:set-design.
     ====================================================================== */
  function initLooks(root) {
    var ac = new AbortController(), sig = { signal: ac.signal };
    var stage = root.querySelector('[data-pl-looks-stage]');
    var blank = root.querySelector('[data-pl-looks-blank]');
    var portrait = root.querySelector('[data-pl-illo-portrait]');
    var ph = root.querySelector('[data-pl-illo-ph]');
    var nameEl = root.querySelector('[data-pl-illo-name]');
    var rail = root.querySelector('[data-pl-looks-rail]');
    var shown = null;
    var paintNotes = Array.prototype.slice.call(root.querySelectorAll('[data-pl-looks-paint]'));
    root.querySelector('[data-pl-illo-pick]').addEventListener('click', function () { document.dispatchEvent(new CustomEvent('pl:pick-photo')); }, sig);
    // Typing their name on the blanket fills the buy box's name field (which updates state and the rest of the page)
    nameEl.addEventListener('input', function () {
      var field = document.querySelector('#pl-name'); if (!field) return;
      field.value = nameEl.value; field.dispatchEvent(new Event('input', { bubbles: true }));
    }, sig);
    nameEl.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); nameEl.blur(); } }, sig);
    // their name and font here are kept in step with the buy box
    var nameIn2 = root.querySelector('[data-pl-looks-name-in]');
    nameIn2.addEventListener('input', function () {
      var field = document.querySelector('#pl-name'); if (!field) return;
      field.value = nameIn2.value; field.dispatchEvent(new Event('input', { bubbles: true }));
    }, sig);
    root.querySelectorAll('input[name="looks_font"]').forEach(function (r) {
      r.addEventListener('change', function () {
        var main = document.querySelector('input[name="font"][value="' + r.value + '"]'); if (main) main.click();
      }, sig);
    });

    rail.innerHTML = '';
    var buttons = DESIGNS.map(function (d) {
      var li = document.createElement('li');
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'pl-look'; b.setAttribute('aria-pressed', 'false'); b.dataset.design = d.name;
      var tile = document.createElement('span'); tile.className = 'pl-look__tile'; paintDesign(tile, d);
      var label = document.createElement('span'); label.textContent = d.name;
      b.appendChild(tile); b.appendChild(label); li.appendChild(b); rail.appendChild(li);
      b.addEventListener('click', function () { document.dispatchEvent(new CustomEvent('pl:set-design', { detail: d.name })); }, sig);
      return b;
    });
    rail.addEventListener('keydown', function (e) {
      var i = buttons.indexOf(document.activeElement); if (i < 0) return;
      var n = e.key === 'ArrowRight' || e.key === 'ArrowDown' ? i + 1 : e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? i - 1 : e.key === 'Home' ? 0 : e.key === 'End' ? buttons.length - 1 : null;
      if (n === null) return;
      e.preventDefault(); buttons.forEach(function (b) { b.tabIndex = -1; }); var t = buttons[(n + buttons.length) % buttons.length]; t.tabIndex = 0; t.focus();
    }, sig);

    // The real blanket in the chosen design: an oval placeholder until they add a photo, then their photo
    function render() {
      var d = design(state.design);
      var key = d.name + '|' + state.photo; // not the name: typing shouldn't re-fade the preview
      if (key !== shown && shown !== null && !reduceMotion.matches) {
        stage.classList.remove('is-swapping'); void stage.offsetWidth; stage.classList.add('is-swapping');
      }
      shown = key;
      if (new URL(blank.getAttribute('src') || '', location.href).href !== new URL(d.blank, location.href).href) { blank.src = d.blank; blank.srcset = d.blank + ' 720w, ' + d.blankBig + ' 1200w'; }
      blank.alt = 'Everyday Love Blanket ' + d.name + ' Printed Love';
      if (document.activeElement !== nameEl) nameEl.value = state.name; // typed here or in the buy box, both stay in sync
      nameEl.classList.toggle('is-empty', !state.name);
      if (document.activeElement !== nameIn2) nameIn2.value = state.name;
      var fr = root.querySelector('input[name="looks_font"][value="' + state.font + '"]'); if (fr) fr.checked = true;
      nameEl.style.setProperty('--ink', d.light ? '#FCEDDE' : '#342E2A');
      var img = portrait.querySelector('img.pl-illo__photo');
      if (state.photo) {
        if (!img) { img = document.createElement('img'); img.className = 'pl-illo__photo'; img.alt = ''; portrait.appendChild(img); }
        img.src = state.photo; portrait.classList.add('has-photo'); ph.hidden = true;
      } else { if (img) img.remove(); portrait.classList.remove('has-photo'); ph.hidden = false; }
      // their raw photo is only a preview: say plainly that it gets painted before printing
      paintNotes.forEach(function (n) { n.hidden = !state.photo; });
      // one Tab stop for the whole row; arrow keys move between designs
      buttons.forEach(function (b) { var on = b.dataset.design === d.name; b.setAttribute('aria-pressed', String(on)); b.tabIndex = on ? 0 : -1; });
      root.querySelector('[data-pl-looks-status]').textContent = d.name;
      root.querySelector('[data-pl-looks-name]').textContent = d.name; // quiet corner label on the preview
    }
    document.addEventListener('pl:change', render, sig);
    render();
    return function destroy() { ac.abort(); };
  }

  /* ======================================================================
     MODULE: size guide: plan-view room scenes, one scale for all three.
     3 px = 1 in, grid square = 12 in. Furniture at typical U.S. sizes.
     ====================================================================== */
  var PX = 3;
  function r(x, y, w, h, cls, rx) { return '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" rx="' + (rx || 0) + '" class="' + cls + '"/>'; }
  var patSeq = 0;
  function blanketSvg(x, y, w, h, d) {
    // the real swatch art, cropped to fill the blanket (objectBoundingBox pattern)
    var id = 'pl-pat-' + (++patSeq);
    var s = '<defs><pattern id="' + id + '" patternContentUnits="objectBoundingBox" width="1" height="1">' +
      '<image href="' + d.art + '" width="1" height="1" preserveAspectRatio="xMidYMid slice"/></pattern></defs>' +
      '<g><rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" rx="3" class="blanket" fill="' + d.sw + '"/>' +
      '<rect x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" rx="3" fill="url(#' + id + ')"/>';
    // The design as printed: name centred near the top, an oval portrait centred below it (as in "Which one feels like them?").
    // Drawn in the blanket's own upright frame (0..1), turned 90° when the blanket lies sideways (wider than tall).
    var side = w > h, fx = side ? 'translate(' + x + ' ' + (y + h) + ') rotate(-90) scale(' + h + ' ' + w + ')' : 'translate(' + x + ' ' + y + ') scale(' + w + ' ' + h + ')';
    s += '<g transform="' + fx + '">' +
      '</g></g>'; // just the chosen design: no placeholder portrait or name bar
    return s;
  }
  function dims(x, y, w, h, wLabel, hLabel, below) {
    var yb = y + h + 12, xr = x + w + 12;
    return '<path class="dim" d="M' + x + ' ' + (yb - 4) + 'v8M' + (x + w) + ' ' + (yb - 4) + 'v8M' + x + ' ' + yb + 'H' + (x + w) + '"/>' +
      '<text class="dimtxt" x="' + (x + w / 2) + '" y="' + (yb + 15) + '" text-anchor="middle">' + wLabel + '</text>' +
      '<path class="dim" d="M' + (xr - 4) + ' ' + y + 'h8M' + (xr - 4) + ' ' + (y + h) + 'h8M' + xr + ' ' + y + 'V' + (y + h) + '"/>' +
      '<text class="dimtxt" x="' + (xr + 6) + '" y="' + (y + h / 2 + 4) + '">' + hLabel + '</text>';
  }
  function scene(size, d) {
    var W = 330, H = 312, g = '';
    for (var gx = 0; gx <= W; gx += 12 * PX) g += '<line class="grid" x1="' + gx + '" y1="0" x2="' + gx + '" y2="' + H + '"/>';
    for (var gy = 0; gy <= H; gy += 12 * PX) g += '<line class="grid" x1="0" y1="' + gy + '" x2="' + W + '" y2="' + gy + '"/>';
    var s = '<rect class="floor" width="' + W + '" height="' + H + '"/>' + g, title;
    if (size === 'small') {
      title = 'Plan view of a 30 by 40 inch blanket laid over a 34 inch armchair, to scale';
      s += '<ellipse class="rug" cx="160" cy="165" rx="130" ry="118"/>';
      s += r(111, 42, 102, 102, 'furn', 16) + r(111, 42, 102, 24, 'furn-2', 12) + r(111, 42, 16, 102, 'furn-2', 10) + r(197, 42, 16, 102, 'furn-2', 10);
      s += '<circle cx="268" cy="70" r="24" class="furn-3"/><circle cx="268" cy="70" r="12" class="leaf"/>';
      s += blanketSvg(117, 90, 30 * PX, 40 * PX, d) + dims(117, 90, 30 * PX, 40 * PX, '30 in', '40 in');
      s += '<text class="lbl" x="12" y="22">ARMCHAIR · 34 IN WIDE</text>';
    } else if (size === 'medium') {
      title = 'Plan view of a 50 by 60 inch blanket spread across an 84 inch sofa, to scale';
      s += r(24, 150, 282, 150, 'rug', 10);
      s += r(39, 24, 252, 108, 'furn', 14) + r(39, 24, 252, 27, 'furn-2', 10) + r(39, 24, 21, 108, 'furn-2', 10) + r(270, 24, 21, 108, 'furn-2', 10);
      s += r(105, 250, 120, 54, 'furn-3', 10);
      s += blanketSvg(90, 40, 50 * PX, 60 * PX, d) + dims(90, 40, 50 * PX, 60 * PX, '50 in', '60 in'); // upright, the way the design reads
      s += '<text class="lbl" x="12" y="16">SOFA · 84 IN WIDE</text>';
    } else {
      title = 'Plan view of a 60 by 80 inch blanket covering a queen bed, to scale';
      s += r(69, 22, 192, 14, 'furn-2', 4);
      s += r(75, 36, 180, 240, 'furn', 6);
      s += r(9, 30, 54, 48, 'furn-3', 6) + r(267, 30, 54, 48, 'furn-3', 6) + '<circle cx="36" cy="54" r="10" class="leaf"/>';
      s += blanketSvg(75, 36, 60 * PX, 80 * PX, d);
      s += r(84, 44, 78, 48, 'pillow-under', 12) + r(168, 44, 78, 48, 'pillow-under', 12); // under the blanket: dotted outlines
      s += dims(75, 36, 60 * PX, 80 * PX, '60 in', '80 in');
      s += '<text class="lbl" x="12" y="16">QUEEN BED · 60 × 80 IN</text>';
    }
    return '<svg viewBox="0 0 ' + W + ' ' + H + '" role="img" aria-label="' + title + '"><title>' + title + '</title>' + s + '</svg>';
  }

  function initSize(root) {
    var ac = new AbortController(), sig = { signal: ac.signal };
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    var panel = root.querySelector('[data-pl-size-panel]');
    var sceneEl = root.querySelector('[data-pl-scene]');
    var viewing = state.size, drawn = '';

    function show(size, focus) {
      viewing = size;
      var s = SIZES[size];
      tabs.forEach(function (t) {
        var on = t.dataset.size === size;
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
        if (on) { panel.setAttribute('aria-labelledby', t.id); if (focus) t.focus(); }
      });
      var key = size + '|' + state.design;
      if (key !== drawn) { sceneEl.innerHTML = scene(size, design(state.design)); drawn = key; }
      root.querySelector('[data-pl-size-dim]').innerHTML = s.label + ' <span>' + s.cm + '</span>';
      root.querySelector('[data-pl-size-use]').textContent = s.use;
      root.querySelector('[data-pl-size-price]').textContent = money(PRICES[size]);
      syncChosen();
    }
    function syncChosen() {
      var chosen = viewing === state.size && state.sizeSet; // the preselected Medium only counts once they choose it
      root.querySelector('[data-pl-size-choose]').hidden = chosen;
      root.querySelector('[data-pl-size-chosen]').hidden = !chosen;
      root.querySelector('[data-pl-size-chosen-name]').textContent = { small: 'Small', medium: 'Medium', large: 'Large' }[viewing];
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { show(t.dataset.size); }, sig);
      t.addEventListener('keydown', function (e) {
        var k = e.key, n = null;
        if (k === 'ArrowRight') n = (i + 1) % tabs.length;
        if (k === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
        if (k === 'Home') n = 0;
        if (k === 'End') n = tabs.length - 1;
        if (n !== null) { e.preventDefault(); show(tabs[n].dataset.size, true); }
      }, sig);
    });
    root.querySelector('[data-pl-size-choose]').addEventListener('click', function () {
      document.dispatchEvent(new CustomEvent('pl:set-size', { detail: viewing }));
      syncChosen();
      root.querySelector('[data-pl-size-chosen]').focus();
    }, sig);
    var lastSize = state.size;
    document.addEventListener('pl:change', function (e) {
      if (e.detail.size !== lastSize) { lastSize = e.detail.size; show(lastSize); } else show(viewing);
    }, sig);
    show(state.size);
    return function destroy() { ac.abort(); };
  }

  /* ======================================================================
     MODULE: proof (before/after compare: drag, tap or use arrow keys)
     touch-action: pan-y keeps vertical page scrolling; only horizontal
     drags move the divider. One example: a real photo → the finished blanket.
     ====================================================================== */
  function initProof(root) {
    var ac = new AbortController(), sig = { signal: ac.signal };
    function set(ba, pct) {
      pct = Math.max(0, Math.min(100, Math.round(pct)));
      ba.style.setProperty('--pos', pct + '%');
      var h = ba.querySelector('.pl-ba__handle');
      h.setAttribute('aria-valuenow', pct);
      h.setAttribute('aria-valuetext', pct <= 5 ? 'All blanket' : pct >= 95 ? 'All photo' : Math.round(100 - pct) + '% blanket');
    }
    root.querySelectorAll('[data-pl-ba]').forEach(function (ba) {
      var dragging = false, startX = 0, startY = 0, decided = false;
      function fromEvent(e) { var r = ba.getBoundingClientRect(); return (e.clientX - r.left) / r.width * 100; }
      ba.addEventListener('pointerdown', function (e) {
        dragging = true; decided = false; startX = e.clientX; startY = e.clientY;
        if (e.pointerType === 'mouse') { decided = true; ba.classList.add('is-dragging'); set(ba, fromEvent(e)); }
        try { ba.setPointerCapture(e.pointerId); } catch (err) {}
      }, sig);
      ba.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        if (!decided) {
          var dx = Math.abs(e.clientX - startX), dy = Math.abs(e.clientY - startY);
          if (dx < 6 && dy < 6) return;
          if (dy > dx) { dragging = false; return; } // a vertical swipe: let the page scroll
          decided = true; ba.classList.add('is-dragging');
        }
        set(ba, fromEvent(e));
      }, sig);
      function end(e) {
        if (dragging && !decided && e && e.type === 'pointerup') set(ba, fromEvent(e)); // a tap jumps the divider
        dragging = false; ba.classList.remove('is-dragging');
      }
      ba.addEventListener('pointerup', end, sig);
      ba.addEventListener('pointercancel', end, sig);
      ba.querySelector('.pl-ba__handle').addEventListener('keydown', function (e) {
        var now = +this.getAttribute('aria-valuenow'), step = { ArrowLeft: -5, ArrowDown: -5, ArrowRight: 5, ArrowUp: 5, PageDown: -20, PageUp: 20 }[e.key];
        if (e.key === 'Home') { e.preventDefault(); return set(ba, 0); }
        if (e.key === 'End') { e.preventDefault(); return set(ba, 100); }
        if (step) { e.preventDefault(); set(ba, now + step); }
      }, sig);
    });
    return function destroy() { ac.abort(); };
  }

  /* ---------------- registry + Shopify editor lifecycle ---------------- */
  // Order matters on first load: listeners (looks, size, transform) mount before
  // product emits its initial state.
  var MODULES = { transform: initTransform, looks: initLooks, size: initSize, proof: initProof, product: initProduct }; // header/footer/cart: shared/site.js
  var ORDER = ['transform', 'looks', 'size', 'proof', 'product'];
  var live = new Map();
  function mount(el) {
    var fn = MODULES[el.getAttribute('data-pl-section')];
    if (!fn || live.has(el)) return;
    live.set(el, fn(el));
  }
  function unmount(el) {
    var d = live.get(el);
    if (d) { d(); live.delete(el); }
  }
  function scan(scope) {
    var els = [];
    if (scope.matches && scope.matches('[data-pl-section]')) els.push(scope);
    scope.querySelectorAll('[data-pl-section]').forEach(function (el) { els.push(el); });
    els.sort(function (a, b) { return ORDER.indexOf(a.getAttribute('data-pl-section')) - ORDER.indexOf(b.getAttribute('data-pl-section')); });
    els.forEach(mount);
  }
  document.addEventListener('shopify:section:load', function (e) { loadConfig(); scan(e.target); emit(); });
  document.addEventListener('shopify:section:unload', function (e) {
    e.target.querySelectorAll('[data-pl-section]').forEach(unmount);
    if (e.target.matches('[data-pl-section]')) unmount(e.target);
  });
  loadConfig(); (cfg().designs.length) && scan(document);
  addEventListener('pagehide', function () { if (state.localUrl) URL.revokeObjectURL(state.localUrl); });
})();
